<template>
  <div class="text-center lead" style="padding-top: 15%">
    Ooops, it seems you don't have access to any BOLT Jobs.<br />
    Please contact BOLT administrators for any questions.
  </div>
</template>

<script>
export default {
  name: "JobNoAccess",
};
</script>
